import React from 'react';
import { TEXT_LANGS, LANGUAGE_LABELS } from '../utils/clientTexts';

/**
 * Small language tab switcher used above the client-view text editing sections
 * in TemplateEditor, BrandingSettings, and UserSettings.
 *
 * Shows one tab per supported language (EN / PL / DE). The active tab is the
 * language currently being edited; clicking a tab switches which language's
 * fields are shown.
 */
const LanguageTabs = ({ value, onChange, testId = 'lang-tabs' }) => {
  return (
    <div
      data-testid={testId}
      style={{
        display: 'flex',
        gap: '4px',
        marginBottom: '16px',
        borderBottom: '1px solid var(--kahla-border)',
        paddingBottom: '0',
      }}
    >
      {TEXT_LANGS.map(lang => {
        const active = value === lang;
        return (
          <button
            key={lang}
            type="button"
            onClick={() => onChange(lang)}
            data-testid={`${testId}-${lang}`}
            style={{
              padding: '8px 16px',
              fontSize: '12px',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              border: 'none',
              borderBottom: active ? '2px solid var(--kahla-charcoal)' : '2px solid transparent',
              marginBottom: '-1px',
              background: 'transparent',
              color: active ? 'var(--kahla-charcoal)' : 'var(--kahla-text-light)',
              cursor: 'pointer',
              fontFamily: 'inherit',
              fontWeight: active ? '600' : '400',
            }}
          >
            {lang.toUpperCase()}
            <span style={{ fontSize: '10px', marginLeft: '6px', opacity: 0.6, textTransform: 'none', letterSpacing: '0.02em' }}>
              {LANGUAGE_LABELS[lang]}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default LanguageTabs;
